<template>
    <span class="opt-out-modal">
        <span class="pointer " style="max-width: 300px; text-align: center;" @click="openModal">
            <button class="modal-button"
                :style="{borderColor: this.marketingPrimary, color: this.buttonColor}">View Enrollment
                Options</button>
        </span>
        <div class="modal-backdrop" v-show="isModalVisible">
            <div class="modal-container" :name="modalId" style="align-items: center; max-width: 610px; margin: auto; padding-top: 5%;">
                <div class="onboard-prop">
                    <svg style="position: relative; top: 5px;" width="25px" height="25px" viewBox="0 0 19 19"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="a" style="maskType: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="2"
                            height="2">
                            <path fill="#1F6F07" d="M0 0H19V19H0z" />
                        </mask>
                        <path
                            d="M9.5 9.518c.4 0 .74-.14 1.018-.417.277-.277.416-.616.416-1.018 0-.401-.138-.74-.416-1.018a1.387 1.387 0 00-1.019-.416c-.4 0-.74.139-1.018.416a1.385 1.385 0 00-.416 1.018c0 .402.139.741.416 1.018.278.278.617.417 1.018.417zm0 5.011c1.404-1.299 2.443-2.47 3.116-3.515s1.01-1.974 1.01-2.79c0-1.274-.396-2.304-1.187-3.089-.791-.785-1.771-1.178-2.94-1.178-1.168 0-2.148.393-2.939 1.178-.79.785-1.186 1.815-1.186 3.09 0 .815.336 1.744 1.009 2.789.673 1.045 1.712 2.216 3.116 3.515zm0 2.125c-1.925-1.676-3.36-3.2-4.303-4.568-.945-1.37-1.417-2.657-1.417-3.861 0-1.807.572-3.235 1.718-4.286 1.144-1.05 2.478-1.576 4.001-1.576 1.524 0 2.858.529 4.002 1.586 1.146 1.056 1.718 2.481 1.718 4.276 0 1.204-.472 2.49-1.417 3.86-.944 1.37-2.378 2.893-4.303 4.57z"
                            :style="{fill: this.marketingPrimary}" />
                    </svg>
                    <span class="propHeader">
                        {{marketingName ? marketingName : projectName}}
                    </span>
                </div>
                <div @click="closeModal" class="x-button"><img src="../../../../public/img/close_x.svg" alt="X" /></div>

                <div v-if="modalInt === 1" class="innerModal modal-fade">
                    <div class="head-one row">
                        <div class="char-text title">Your Enrollment <span
                                :style="{color: this.marketingPrimary}">Options</span></div>
                        <div class="light-text desc">{{projectSuffix}} starts on {{this.date}}</div>
                    </div>
                    <div class="bottom-row">
                        <div class="row-pad">
                            <div class="cardWrap">
                                <div :class="{infoCard: continueSelector === true, infoCardTwo: continueSelector === false}"
                                    :style="{borderColor: this.marketingPrimary}" @click="continueSelectorTrue">
                                    <div class="radio-position radio-border"
                                        :style="{borderColor: this.marketingPrimary}">
                                        <div v-if="continueSelector ==  true" class="highlight"
                                            :style="{backgroundColor: this.marketingPrimary}"
                                            @click="continueSelectorTrue"></div>
                                        <div v-else class="highlight" @click="continueSelectorTrue"></div>
                                    </div>

                                    <div class="char-text" style="padding-bottom: 30px;">
                                        Stay Enrolled
                                    </div>
                                    <div class="light-text-p">
                                        {{projectSuffix}} will be made available on {{this.monthDate}}. All you
                                        need to do is create an account to get started.
                                    </div>
                                </div>
                            </div>
                            <div style="max-height: 200px">
                                <div v-if="continueSelector === true" class="check-list"
                                    :style="{borderColor: this.marketingPrimary}">
                                    <ul class="checklisttrans">
                                        <li v-if="projectFree">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px;" /><span class="list-span">First
                                                30 days are free</span>
                                        </li>
                                        <li v-if="projectMatch">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px;" /><span class="list-span">Get
                                                price matched with current plan</span>
                                        </li>
                                        <li v-if="projectReimbursement">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px;" /><span class="list-span">We
                                                cover 100% of cancellation fees</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else class="check-trans">
                                    <ul class="checklisttrans">
                                        <li v-if="projectFree">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px; opacity: 0;" /><span class="list-span">First
                                                30 days are free</span>
                                        </li>
                                        <li v-if="projectMatch">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px; opacity: 0;" /><span class="list-span">Get
                                                price matched with current plan</span>
                                        </li>
                                        <li v-if="projectReimbursement">
                                            <img src="../../../../public/img/check_small.svg" alt="Check"
                                                style="position: relative; bottom: 2px; opacity: 0;" /><span class="list-span">We
                                                cover 100% of cancellation fees</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row-pad">
                            <div class="cardWrap">
                                <div :class="{infoCardThree: continueSelector === false, infoCardFour: continueSelector === true}"
                                    :style="{borderColor: this.marketingPrimary}" @click="continueSelectorFalse">
                                    <div class="char-text" style="padding-bottom: 30px;">
                                        <div class="radio-position radio-border"
                                            :style="{borderColor: this.marketingPrimary}">
                                            <div v-if="continueSelector ==  false" class="highlight"
                                                :style="{backgroundColor: this.marketingPrimary}"
                                                @click="continueSelectorTrue"></div>
                                            <div v-else class="highlight" @click="continueSelectorTrue"></div>
                                        </div>
                                        Opt Out
                                    </div>
                                    <div class="light-text-p">
                                        You may have the option to wait until lease renewal before the {{projectSuffix}}
                                        fee
                                        is charged with rent.
                                    </div>
                                </div>
                            </div>
                            <div v-if="continueSelector === false" class="opt-list"
                                :style="{borderColor: this.marketingPrimary}">
                                <ul class="checklisttrans">
                                    <li v-if="projectFree">
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">Miss out
                                            on 30 days free</span>
                                    </li>
                                    <li v-if="projectReimbursement">
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">No
                                            cancellation reimbursement</span>
                                    </li>
                                    <li>
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">Amenity
                                            Fee will still be added at lease renewal</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else class="opt-trans ot-mobile">
                                <ul class="checklisttrans">
                                    <li v-if="projectFree">
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">Miss out
                                            on 30 days free</span>
                                    </li>
                                    <li v-if="projectReimbursement">
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">No
                                            cancellation reimbursement</span>
                                    </li>
                                    <li>
                                        <img src="../../../../public/img/error_circle.svg" alt="Wait"
                                            style="position: relative; bottom: 2px;" /><span class="list-span">Amenity
                                            Fee will still be added at lease renewal</span>
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div class="row-pad-2">
                            <div v-if="continueSelector === true">
                                <a :href="this.url">
                                    <button class="continue-button" :style="{backgroundColor: this.marketingPrimary}">
                                        Continue
                                    </button>
                                </a>
                            </div>
                            <div v-else>
                                <button class="continue-button" :style="{backgroundColor: this.marketingPrimary}"
                                    @click="modalTwo">
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div v-else-if="modalInt === 2" class=" modal-fade innerModal">
                    <div class="head-one row">
                        <div class="char-text title-2">{{projectSuffix}} Opt Out Request</div>

                    </div>

                    <form @submit.prevent="submit" method="POST" accept-charset="UTF-8" ref="formRef">

                        <div class="form-input">
                            <div class="input-div" :class="{'has-error': errors.has('full-name')}">
                                <input class="input-style full-name" id="full-name" type="text" name="full-name"
                                    placeholder=" " required v-model="userInfo.name" />
                                <label class="label-form" for="full-name">Full Name</label>
                                <span v-show="errors.has('full-name')" class="help-block">
                                    {{ errors.first('full-name') }}
                                </span>
                            </div>
                            <div class="input-div" :class="{'has-error': errors.has('email')}">
                                <input name="email" class="input-style email" id="email" type="email" placeholder=" "
                                    required v-model="userInfo.email" />
                                <label class="label-form" for="email">Email</label>
                                <span v-show="errors.has('email')" class="help-block">
                                    {{ errors.first('email') }}
                                </span>
                            </div>
                            <div class="input-div" :class="{'has-error': errors.has('phone')}">
                                <input name="phone" id="phone" minlength="12" maxlength="14" class="input-style phone"
                                    type="tel" placeholder="###-###-####" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" required
                                    v-mask="`###-###-####`" v-model="telephoneNum" />
                                <label class="label-form" for="phone">Phone</label>
                                <span v-show="errors.has('phone')" class="help-block">
                                    {{ errors.first('phone') }}
                                </span>
                            </div>
                            <div class="input-div" :class="{'has-error': errors.has('address')}">
                                <input name="address" class="input-style address" id="address" type="address"
                                    placeholder=" " required v-model="userInfo.address" />
                                <label class="label-form" for="address">Address</label>
                                <span v-show="errors.has('address')" class="help-block">
                                    {{ errors.first('address') }}
                                </span>
                            </div>
                            <div class="input-div align-left" style="width: 100%">
                                <span class="input-style-1">Opt Out Reason</span>
                            </div>
                            <div class="input-div" :class="{'has-error': errors.has('reason')}">
                                <label for="reason"
                                    style="z-index: 10; pointer-events: none; position: absolute; left: initial; padding: initial; background: initial; right: 20px; top: 16px; font-size: x-large;">
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </label>
                                <select name="reason" class="input-style dropdown" v-validate="'required'"
                                    aria-required="true" required v-model="userInfo.reason"
                                    placeholder="Opt Out Reason">
                                    <option value="" disabled selected hidden>Opt Out Reason</option>
                                    <option value=2>I'm currently paying less for similar services.</option>
                                    <option value=3>I'm moving out soon.</option>
                                    <option value=4>I don't want to switch providers.</option>
                                    <option value=5>I already utilize services from this provider.</option>
                                    <option value=1>Other . . .</option>
                                </select>
                                <span v-show="errors.has('reason')" class="help-block">
                                    {{ errors.first('reason') }}
                                </span>
                            </div>
                            <div v-if="(userInfo.reason === '5' && !isXfinity()) || ['2', '4'].includes(userInfo.reason)"
                                class="input-div" :class="{
                                        selectUpsellSeven: !projectMatch && userInfo.reason == '2',
                                        selectUpsell: projectMatch && userInfo.reason == '2',
                                        selectUpsellThree: userInfo.reason === '1',
                                        selectUpsellTwo: userInfo.reason === null,
                                        selectUpsellFour: userInfo.reason == '3',
                                        selectUpsellFive: userInfo.reason == '4',
                                        selectUpsellSix: userInfo.reason == '5',
                                        }">
                                <div v-if="userInfo.reason == '2'">
                                    <span class="char-text">We can price match!</span>
                                    <p class="light-text-up">If you are currently paying less than ${{projPrice}} per
                                        month,
                                        we can
                                        price match your current rate!
                                        Create an account with us and submit a price match request.
                                    </p>
                                </div>
                                <div v-else-if="userInfo.reason == '4'">
                                    <span class="char-text">Are you sure?</span>
                                    <p class="light-text-up">
                                        There is no cost to switch, we'll cover any early cancellation fees from
                                        your previous provider and even price match your current rate.
                                    </p>
                                </div>
                                <div v-else-if="userInfo.reason == '5'">
                                    <span class="char-text">Great!</span>
                                    <p class="light-text-up">
                                        In most cases the service provider will apply the {{this.projectSuffix}}
                                        discount code to your account without affecting your current services. Just
                                        create an account or call us to verify your options.
                                    </p>
                                </div>

                                <a :href="this.url" class="create-acc"
                                    :style="{backgroundColor: this.marketingPrimary}">
                                    Create an account
                                </a>
                            </div>
                            <div v-if="userInfo.reason === '1'" class="input-div"
                                :class="{'has-error': errors.has('other')}">
                                <input name="other" class="input-style other" type="text" placeholder=" " required
                                    v-model="userInfo.other" />
                                <label class="label-form" for="other">Other</label>
                                <span v-show="errors.has('other')" class="help-block">
                                    {{ errors.first('other') }}
                                </span>
                            </div>
                            <div v-if="!((userInfo.reason === '5' && !isXfinity()) || ['2', '4'].includes(userInfo.reason))"
                                class="input-div submit-button-2">
                                <button v-if="isDisabled" disabled type="submit" class="form-sub-button"
                                    style="color:beige; opacity: .4;" :style="{backgroundColor: this.marketingPrimary}">
                                    Submit
                                </button>
                                <button v-else type="submit" class="form-sub-button"
                                    :style="{backgroundColor: this.marketingPrimary}">
                                    Submit
                                </button>
                            </div>
                            <div v-else-if="userInfo.reason === '2'" class="input-div submit-button">
                                <button v-if="isDisabled" disabled type="submit" class="form-sub-button-1"
                                    style="color:beige; opacity: .4;"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                                <button v-else type="submit" class="form-sub-button-1"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                            </div>
                            <div v-else-if="userInfo.reason === '4'" class="input-div submit-button">
                                <button v-if="isDisabled" disabled type="submit" class="form-sub-button-1"
                                    style="color:beige; opacity: .4;"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                                <button v-else type="submit" class="form-sub-button-1"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                            </div>
                            <div v-else-if="userInfo.reason === '5'" class="input-div submit-button">
                                <button v-if="isDisabled" disabled type="submit" class="form-sub-button-1"
                                    style="color:beige; opacity: .4;"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                                <button v-else type="submit" class="form-sub-button-1"
                                    :style="{borderColor: this.marketingPrimary, color: this.marketingPrimary}">
                                    No thanks, submit my opt out request
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
                <div v-else-if="modalInt === 3" class="last-modal">
                    <div class="head-one last-in">
                        <div class="char-text title-3">Request Submitted - Pending Review</div>
                        <div class="green-line" :style="{borderColor: this.marketingPrimary}"></div>
                        <div class="light-text last-p">One of our support agents will review your request. You will
                            receive an email confirmation soon.
                            <br /><br />
                            <span style="position: relative; paddingTop: 5px;">
                                <i :style="{fontSize: '12px', marginTop: '15px;'}">Note: Not all leases are eligible to
                                    opt out of amenity charges. Your request will be reviewed and approved based on
                                    eligibility.</i>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-else-if="modalInt === 4" class="last-modal" style="max-width: 823px;">
                    <div class="head-one last-in">
                        <div>
                            <svg style="position: relative; top: 25px;" width="35px" height="35px" viewBox="0 0 19 19"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="a" style="maskType: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="2"
                                    height="2">
                                    <path fill="#40474E" d="M0 0H19V19H0z" />
                                </mask>
                                <path
                                    d="M6.297 9.594C6.526 9.594 6.71875 9.51575 6.87525 9.35925C7.03125 9.20325 7.10925 9.0105 7.10925 8.781C7.10925 8.552 7.03125 8.35675 6.87525 8.19525C6.71875 8.03375 6.526 7.953 6.297 7.953C6.068 7.953 5.87525 8.03375 5.71875 8.19525C5.56275 8.35675 5.48475 8.552 5.48475 8.781C5.48475 9.0105 5.56275 9.20325 5.71875 9.35925C5.87525 9.51575 6.068 9.594 6.297 9.594ZM5.53125 7.06275H7.06275V3.1095H5.53125V7.06275ZM6.297 12.594C5.422 12.594 4.60425 12.43 3.84375 12.102C3.08325 11.7735 2.4165 11.323 1.8435 10.7505C1.271 10.1775 0.8205 9.51075 0.492 8.75025C0.164 7.98975 0 7.172 0 6.297C0 5.4115 0.164 4.59125 0.492 3.83625C0.8205 3.08075 1.271 2.41675 1.8435 1.84425C2.4165 1.27125 3.08325 0.8205 3.84375 0.492C4.60425 0.164 5.422 0 6.297 0C7.1825 0 8.00275 0.164 8.75775 0.492C9.51325 0.8205 10.1775 1.27125 10.7505 1.84425C11.323 2.41675 11.7735 3.08325 12.102 3.84375C12.43 4.60425 12.594 5.422 12.594 6.297C12.594 7.172 12.43 7.98975 12.102 8.75025C11.7735 9.51075 11.323 10.1775 10.7505 10.7505C10.1775 11.323 9.51075 11.7735 8.75025 12.102C7.98975 12.43 7.172 12.594 6.297 12.594ZM6.297 11.0625C7.6305 11.0625 8.758 10.6015 9.6795 9.6795C10.6015 8.758 11.0625 7.6305 11.0625 6.297C11.0625 4.9635 10.6015 3.836 9.6795 2.9145C8.758 1.9925 7.6305 1.5315 6.297 1.5315C4.9635 1.5315 3.836 1.9925 2.9145 2.9145C1.9925 3.836 1.5315 4.9635 1.5315 6.297C1.5315 7.6305 1.9925 8.758 2.9145 9.6795C3.836 10.6015 4.9635 11.0625 6.297 11.0625Z"
                                    fill="#40474E" />

                            </svg>
                        </div>
                        <div class="char-text title-3">There was an error submitting your request.</div>
                        <div class="red-line"></div>
                        <div class="light-text last-p">Sorry! Something went wrong on our end.</div>
                        <div class="light-text last-p">Please call us directly at <a :href="`tel:{{this.supportNum}}`"
                                :style="{color: this.marketingPrimary}">{{this.supportNum}}</a> or <a
                                href="javascript://void(0)" class="_chat-link" :style="{color: this.marketingPrimary}">
                                open a chat</a> to submit your request.</div>

                    </div>
                </div>
                <div v-else="modalInt === 5" class="last-modal">
                    <div class="head-one last-in">
                        <div class="char-text title-3">You’ve already submitted a request to Opt Out.</div>
                        <div class="green-line" :style="{borderColor: this.marketingPrimary}"></div>
                        <div class="light-text last-p">We received your request to opt out on {{this.submitDate}}. It
                            typically takes 2-3 days to process this request, but sometimes it may take longer.</div>
                        <div class="light-text last-p">If you haven’t received any response you can call us at
                            <br /><a :href="`tel:{{this.supportNum}}`"
                                :style="{color: this.marketingPrimary}">{{this.supportNum}}</a>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
    import Vue from "vue";
    import VueMask from 'v-mask'
    Vue.use(VueMask);

    export default {
        props: {
            modalId: {
                default: Math.random().toString(),
                type: String
            },
            appUrl: {
                required: true,
                type: String
            },
            projectSlug: {
                required: true,
                type: String
            },
            projectName: {
                required: true,
                type: String
            },
            marketingName: {
              required: false,
              type: String
            },
            projectGolive: {
                required: true,
                type: String
            },
            marketingPrimary: {
                required: true,
                type: String,
            },
            projectSupport: {
                required: true,
                type: String,
            },
            projectMatch: {
                required: true,
                type: String,
            },
            projectReimbursement: {
                required: true,
                type: String,
            },
            projectSuffix: {
                required: true,
                type: String,
            },
            projectFree: {
                required: true,
                type: String,
            },
            projectPrice: {
                required: true,
                type: String,
            },
            projectProvider: {
                required: true,
                type: String,
            },
            buttonColor: {
                required: true,
                type: String
            }
        },
        computed: {
            url() {
                var queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const resident_id = urlParams.get('resident_id');
                const unit_id = urlParams.get('unit_id');
                return `/${this.projectSlug}/register?${resident_id ? 'resident_id=' + resident_id : ''}${unit_id ? '&unit_id=' + unit_id : ''}`;
            }
        },
        data(){
            return {
                loading: false,
                isModalVisible: false,
                modalInt: 0,
                continueSelector: true,
                otherSelect: 0,
                fullName: '',
                telephoneNum: String,
                userInfo: {
                    name: null,
                    email: null,
                    telNum: null,
                    address: null,
                    reason: null,
                    other: null
                },
                date: String,
                supportNum: '',
                twoColor: 'black',
                isDisabled: false,
                isChecked: true,
                isCheckedTwo: false,
                submitDate: '',
                projPrice: '',
            };
        },

        methods: {
            isXfinity() {
                return ['xfinity', 'comcast', 'xfinity-comcast'].includes(this.projectProvider);
            },

            closeModal(){
                this.isModalVisible = false;
                this.clearForm()
            },

            openModal(){
                this.isModalVisible = true;
                this.modalInt = 1;
                this.getDate();
                this.projPrice = Math.floor(this.projectPrice / 100);
            },
            modalTwo(){
                this.modalInt = 2;
                this.isChecked = false;
                this.continueSelectorTrue()
            },
            selector(){
                this.otherSelect = 1;
            },
            continueSelectorTrue() {
                this.continueSelector = true;
                this.isChecked = true;
                this.isCheckedTwo = false;
            },
            continueSelectorFalse() {
                this.continueSelector = false;
            },
            getDate() {
                let options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    timeZone: 'UTC'
                };
                const goLive = this.projectGolive;
                this.date = new Date(goLive).toLocaleDateString('en-US', {timeZone: 'UTC'});
                this.monthDate = new Date(goLive).toLocaleDateString('en-us', options);
            },
            clearForm() {
                this.userInfo = {
                    name: null,
                    email: null,
                    telNum: null,
                    address: null,
                    reason: null,
                    other: null
                };
                this.telephoneNum = null;
            },
            submit(){
                this.isDisabled = true
                const strNumb = this.telephoneNum;     
                this.userInfo.telNum = strNumb.replace(/-/g, "");
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ) {
                            return axios.post( this.projectSlug + '/opt-out/user', {
                                User: this.userInfo
                            })
                            .then((response) => {
                                if (!response.data) {
                                    // Ticket couldn't be created
                                    this.modalInt = 4;
                                    const supNum = this.projectSupport;
                                    this.supportNum = supNum.slice(0,1)+" + ("+supNum.slice(1,4)+") "+supNum.slice(4,7)+"-"+supNum.slice(7);
                                }
                                else {
                                    if (response.data.created) {
                                        // Ticket successfully created
                                        this.modalInt = 3;
                                    }
                                    else if (response.data.ticket) {
                                        // Ticket already created
                                        this.modalInt = 5;
                                        const newDate = response.data.ticket.createdAt
                                        this.submitDate = new Date(newDate).toLocaleDateString('en-US');
                                        const supNum = this.projectSupport;
                                        this.supportNum = supNum.slice(0,1)+" + ("+supNum.slice(1,4)+") "+supNum.slice(4,7)+"-"+supNum.slice(7);
                                    }
                                }
                                this.isDisabled = false;
                            })
                            .catch(() => {
                                this.modalInt = 4;
                                const supNum = this.projectSupport;
                                this.supportNum = supNum.slice(0,1)+" + ("+supNum.slice(1,4)+") "+supNum.slice(4,7)+"-"+supNum.slice(7);
                            })
                            .finally(() => {
                                // Reset modal after changing modal state
                                this.clearForm()
                                this.isDisabled = false;
                            });
                        }
                    } );
            }
        }
    }
</script>
